import { createRouter, createWebHistory } from 'vue-router'
import { Toast } from 'vant'

const routerHistory = createWebHistory()

const routes = [
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { showTabbar: false } 
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home/index.vue'),
    meta: { showTabbar: true } 
  },
  {
    path: '/TrainPlan',
    name: 'TrainPlan',
    component: () => import('../views/Home/TrainPlan/index.vue')
  },
  {
    path: '/TrainingFeedback',
    name: 'TrainingFeedback',
    component: () => import('../views/Home/TrainPlan/TrainingFeedback/index.vue')
  },
  {
    path: '/Questionnaire',
    name: 'Questionnaire',
    component: () => import('../views/Home/Questionnaire/index.vue')
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/My/index.vue'),
    meta: { showTabbar: true } 
  },
  {
    path: '/HistoryQuestionnaire',
    name: 'HistoryQuestionnaire',
    component: () => import('../views/My/HistoryQuestionnaire/index.vue'),
  },
    {
    path: '/QuestionnaireDetail',
    name: 'QuestionnaireDetail',
    component: () => import('../views/My/HistoryQuestionnaire/QuestionnaireDetail/index.vue'),
  },
  {
    path: '/HistoryTrain',
    name: 'HistoryTrain',
    component: () => import('../views/My/HistoryTrain/index.vue'),
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: () => import('../views/My/UserInfo/index.vue')
  },
  {
    path: '/BodyMessage',
    name: 'BodyMessage',
    component: () => import('../views/My/BodyMessage/index.vue')
  },
  {
    path: '/',
    redirect: '/Login'
  }
]

const router = createRouter({
  history: routerHistory,
  routes
})

/**
 * ✅ 路由守卫
 * 如果没有 token 且访问的不是首页(home)，强制跳转回首页并提示
 */
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token')

  // 白名单页面（这些页面不需要登录）
  const whiteList = ['/Login']

  if (!token && !whiteList.includes(to.path)) {
    Toast.fail('请先登录')
    next('/Login')
  } else {
    next()
  }
})

export default router
